<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2022-02-06 08:58:45
 * @LastEditTime: 2022-04-23 11:39:08
 * @FilePath: \raacfold\src\components\selector\SelectedRegion.vue
-->
<template>
    <div>
        <table class="bm-table" style="margin: 0px 0 0 0">
            <tr class="table-header">
                <td colspan="2" style="text-align: center">Selected Region</td>
            </tr>
        </table>
        <el-scrollbar :style="{height: selectedHeight, background:'white'}">
            <div v-if="selected_data.length == 0" style="color: #747d8c; padding: 10px">
                <!-- <center> -->
                    <i class="el-icon-question"></i>
                    In the <strong>Sequence Viewer</strong>, <strong> Mouse swipe the sequence</strong> to select a single region of interest fragment.
                    <img class="img-responsive center-block" src="../../../public/img/selection_help00.gif">
                    
                    <br><i class="el-icon-question"></i>
                    Click <strong>Multiple Region</strong> to select multiple sequence fragments.

                    <br><i class="el-icon-question"></i>
                    In the selected sequence fragment, <strong> Right click </strong>to view more options
                    <img class="img-responsive center-block" src="../../../public/img/selection_help02.gif">
                <!-- </center> -->
            </div>
            <div v-else>
                <SelectedBar v-for="(item, i) in selected_data" :num="i+1" :selected_item="item" :key="i"></SelectedBar>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import SelectedBar from "../raacview/SelectedBar.vue";
    import global_ from "../units/Global";

    export default {
        name: "RaacSelector",
        data() {
            return {
                mainHeight: window.innerHeight - 515 + "px",
                website: global_.website,
                selected_data: [],
                test_data: [{
                    start: '1',
                    end: '5',
                    color: '',
                    representation: ''
                }],
            };
        },
        props: {
            selectedHeight: String,
        },
        components: {
            SelectedBar,
        },
        computed: {},
        watch: {
            "$store.state.sequence_menu"(data) {
                // console.log("$store.state.sequence_menu", data);
                this.render(data);
            },
            '$store.state.raac_scheme'() {
                this.render();
            },
        },
        methods: {
            render(data) {
                this.selected_data = [];
                if (Object.prototype.hasOwnProperty.call(data, "range")) {
                    for (let i = 0; i < data["range"]["start"].length; i++) {
                        // console.log(">>>", data["range"])
                        let start = data["range"]["start"][i];
                        let end = data["range"]["end"][i];
                        let color = data["color"][i];
                        let representation = data["representation"][i];
                        let deleted = data["delete"][i];
                        if (color === "") color = "#ced6e0";
                        if (representation === "") representation = "Ball+stick";
                        this.selected_data.push({
                            'index': i,
                            'start': start,
                            'end': end,
                            'color': color,
                            'representation': representation,
                            'delete': deleted,
                        })
                    }
                }
                // console.log("sequence_menu", data, Object.prototype.hasOwnProperty.call(data, "range"))
                // console.log("selected_data", this.selected_data)
            },
        },
    };
</script>

<style>
    strong {
        color: #ff4757;
    }

    .el-input-group__append,
    .el-input-group__prepend {
        background-color: #f5f7fa;
        color: #909399;
        vertical-align: middle;
        display: table-cell;
        position: relative;
        border: 0px solid #dcdfe6 !important;
        border-radius: 0px;
        padding: 0 20px;
        width: 1px;
        white-space: nowrap;
    }

    table {
        border: 1px solid #ccc;
        color: #4b6584;
        border-top: none;
        margin-bottom: 20px;
    }

    .bm-table td {
        border: 1px solid #ccc;
        padding: 5px 10px 5px 0;
    }

    .bm-table tr {
        border: 1px solid #ccc;
    }

    .bm-table-name {
        width: 70px;
        text-align: right;
        background: #dfe4ea;
    }

    .bm-table-ope {
        width: 210px;
        padding: 0px !important;
    }

    .hr-header {
        /*border-bottom: 1px solid #a4b0be;*/
        padding-bottom: 0px;
    }

    .hr-header p {
        margin-bottom: 0px;
        background: #ffffff;
        width: 331px;
        font-size: 14px;
        padding: 3px 10px 3px 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #a4b0be;
        border-bottom: none;
        text-align: center;
    }
</style>